class {
    handleClick(originalEvent) {
        this.emit('click', { originalEvent });
    }
}
$ {
    const fillThreshold = 0.25;
    const { imageId, imageSize, originalSize = {}, title = "", URL, useUrl, noScaling, noAltTitle, ...attributes } = input;
    const ratio = originalSize.width < originalSize.height
        ? originalSize.width / originalSize.height
        : originalSize.height / originalSize.width;
    const imageClasses = [];
    imageClasses.push(originalSize.width > originalSize.height ? 'landscape' : 'portrait');
    if (noScaling) { imageClasses.push('no-scaling'); }
    if (noAltTitle) { input.noAltTitle === true; }
    if (1 - ratio <= fillThreshold) { imageClasses.push('zoom'); }
}

<${attributes.href ? "a" : "div"} ...attributes onClick("handleClick") class=`str-image-square ${input.class || ""}`>
    <str-image ...input loading="lazy" class=imageClasses.join(" ") />
</>
